import { getLiteral } from 'utils/getLiteral';

export default () => ({
    columnDefs: [
        {
            colId: 'numLine',
            headerName: '#',
            field: 'numLine',
            cellRenderer: 'rowNumberCell',
            width: 60,
            resizable: false,
            pinned: 'left',
            suppressSizeToFit: true,
        },
        {
            colId: 'familyname',
            headerName: getLiteral('label_family'),
            field: 'familyname',
            cellRenderer: 'textCell',
            flex: 1,
            minWidth: 160,
            pinned: 'left',
        },
        {
            colId: 'discount1',
            headerName: getLiteral('label_rates_discount1'),
            field: 'discount1',
            cellRenderer: 'percentageCell',
            cellRendererParams: {
                inputParams: {
                    postComponent: <span>%</span>,
                },
            },
            crudType: 'percentage',
            minWidth: 150,
        },
        {
            colId: 'discount2',
            headerName: getLiteral('label_rates_discount2'),
            field: 'discount2',
            cellRenderer: 'percentageCell',
            cellRendererParams: {
                inputParams: {
                    postComponent: <span>%</span>,
                },
            },
            crudType: 'percentage',
            minWidth: 150,
        },
        {
            colId: 'discount3',
            headerName: getLiteral('label_rates_discount3'),
            field: 'discount3',
            cellRenderer: 'percentageCell',
            cellRendererParams: {
                inputParams: {
                    postComponent: <span>%</span>,
                },
            },
            crudType: 'percentage',
            minWidth: 150,
        },
        {
            colId: 'discount4',
            headerName: getLiteral('label_rates_discount4'),
            field: 'discount4',
            cellRenderer: 'percentageCell',
            cellRendererParams: {
                inputParams: {
                    postComponent: <span>%</span>,
                },
            },
            crudType: 'percentage',
            minWidth: 150,
        },
        {
            colId: 'totalDiscount',
            headerName: getLiteral('label_discount'),
            field: 'totalDiscount',
            cellRenderer: 'textCell',
            cellRendererParams: {
                align: 'right',
            },
            minWidth: 100,
        },
    ],
});
